import DebounceInput from "common/components/DebounceInput/DebounceInput";

function UserSearch(props: any) {
  return <DebounceInput type="text" {...props} />;
}

export default UserSearch;
